export default {
  'am.archive.banner': "This project has been removed from the active catalog and preserved as an archive record.",
  'am.archive.note': "If the concept evolves into a future project, it will be published on a separate page.",
  'am.archive.noteLabel': "// note",
  'am.archive.status.catalog.label': "Catalog Status",
  'am.archive.status.catalog.value': "Inactive",
  'am.archive.status.dev.label': "Development Status",
  'am.archive.status.dev.value': "Stopped",
  'am.archive.status.restart.label': "Restart Plan",
  'am.archive.status.restart.value': "None",
  'am.archive.status.store.label': "Store Release",
  'am.archive.status.store.value': "Not Planned",
  'am.archive.statusLabel': "// archive status",
  'am.breadcrumb.archive': "Archive",
  'am.cta.button': "Back to Games",
  'am.cta.description': "Browse games currently in development.",
  'am.cta.label': "// return to active projects",
  'am.description': "Originally planned as an atmosphere-first story game, Museum of Memories has been removed from active production and fully archived.",
  'am.footer.right': "Archive Record ? Inactive",
  'am.name': "Museum of Memories",
  'am.name.line1': "Museum of",
  'am.name.line2': "Memories",
  'am.note.1.content': "Museum of Memories was designed as a mobile game where players explore an abandoned museum and collect fragments of the past.",
  'am.note.1.title': "Core Idea",
  'am.note.2.content': "Based on current capacity and priorities, the project was removed from active development and archived.",
  'am.note.2.title': "Why It Was Cancelled",
  'am.note.3.content': "Legacy notes and concept documentation remain available on this page as a permanent archive record.",
  'am.note.3.title': "Archive Policy",
  'am.notes.label': "// concept notes",
  'am.notes.unit': "records",
  'am.progress.label': "Development Progress",
  'am.progress.stopped': "Development Halted",
  'am.timeline.1.label': "Idea Phase",
  'am.timeline.1.note': "Initial concept work around atmosphere and memory-based storytelling mechanics.",
  'am.timeline.2.label': "Concept Development",
  'am.timeline.2.note': "Draft gameplay loops, narrative structure, and visual atmosphere references.",
  'am.timeline.3.label': "Removed from Production",
  'am.timeline.3.note': "The project was removed from active production, development stopped, and archive status applied.",
  'am.timeline.label': "// project timeline",
  'app.defterkasa.category': "Finance · Android",
  'app.defterkasa.description': "Professional bookkeeping and accounting for small businesses. Fully offline, no cloud, no subscription.",
  'app.defterkasa.progressLabel': "Production Ready",
  'app.kozmik.category': "Lifestyle · Android - iOS",
  'app.kozmik.description': "A cosmic-themed personal diary. Write your thoughts, dreams, and daily reflections in a beautiful space.",
  'app.kozmik.progressLabel': "Est. 2027",
  'app.pixeldungeon.category': "RPG · Android",
  'app.pixeldungeon.description': "Turn-based pixel RPG with roguelike elements. Explore dungeons, craft gear, and defeat ancient bosses.",
  'app.pixeldungeon.progressLabel': "Concept Phase",
  'app.voidrunner.category': "Arcade · Android",
  'app.voidrunner.description': "A fast-paced endless runner set in a dark void universe. Dodge obstacles, collect energy cores, survive.",
  'app.voidrunner.progressLabel': "Est. 2026 Q4",
  'apps.comingSoon': "Coming Soon",
  'apps.description': "Productivity and lifestyle applications built for Android. Offline-first, privacy-focused, no subscriptions.",
  'apps.devProgress': "Dev Progress",
  'apps.dk.description': "Professional bookkeeping and accounting for small businesses.",
  'apps.dk.longDescription': "Defter Kasa is a fully offline bookkeeping app designed for small business owners, tradespeople, and freelancers. No cloud, no subscription — your data stays on your device. Generate invoices, track expenses, manage customers, and export PDF reports with ease.",
  'apps.dk.name': "Defter Kasa",
  'apps.dk.progressLabel': "Production Ready",
  'apps.dk.stat.downloads': "Downloads",
  'apps.dk.stat.rating': "Rating",
  'apps.dk.stat.size': "Size",
  'apps.dk.stat.version': "Version",
  'apps.dk.tag.customerManagement': "Customer management",
  'apps.dk.tag.expenseTracking': "Expense tracking",
  'apps.dk.tag.invoiceGeneration': "Invoice generation",
  'apps.dk.tag.multiCurrency': "Multi-currency",
  'apps.dk.tag.offlineFirst': "Offline-first",
  'apps.dk.tag.pdfExport': "PDF export",
  /* Defter kasa */
  'apps.dk.value.downloads': "5", /*Defter kasa indirme sayısı */
  'apps.dk.value.rating': "4.8 ?",
  'apps.dk.value.size': "23.9 MB",
  'apps.dk.value.version': "a1.0.1",
  /* Defter kasa */
  'apps.exploreDesc': "Check out our games section too.",
  'apps.exploreMore': "// explore more",
  'apps.googlePlay': "Google Play",
  'apps.kg.description': "A cosmic-themed personal diary for your thoughts and dreams.",
  'apps.kg.longDescription': "Kozmik Günlük is a beautifully designed personal diary app with a cosmic space theme. Write daily entries, track your mood, explore your emotional patterns over time, and keep your thoughts encrypted and private. Coming soon to Google Play.",
  'apps.kg.name': "Kozmik Journal",
  'apps.kg.progressLabel': "Est. 2027",
  'apps.kg.stat.downloads': "Downloads",
  'apps.kg.stat.platform': "Platform",
  'apps.kg.stat.release': "Release",
  'apps.kg.stat.status': "Status",
  'apps.kg.stat.version': "Version",
  'apps.kg.tag.cosmicThemes': "Cosmic themes",
  'apps.kg.tag.dailyJournaling': "Daily journaling",
  'apps.kg.tag.darkUi': "Dark UI",
  'apps.kg.tag.encryptedEntries': "Encrypted entries",
  'apps.kg.tag.moodTracking': "Mood tracking",
  'apps.kg.tag.streakTracking': "Streak tracking",
  'apps.kg.value.release': "2027",
  'apps.kg.value.status': "In Development",
  'apps.kg.value.version': "v0",
  'apps.label': "// applications",
  'apps.live': "Live",
  'apps.title': "Apps",
  'apps.total': "Total Apps",
  'apps.viewDetails': "View Details",
  'apps.viewGames': "View Games",
  'common.items': "items",
  'common.platform.android': "Android",
  'common.value.na': "?",
  'common.value.none': "None",
  'common.value.tbd': "To Be Announced",
  'contact.copied': "✓ Copied",
  'contact.copy': "Copy",
  'contact.description': "Bug report, feature request, partnership, or just want to chat about software — we read every message and respond personally.",
  'contact.err.emailInvalid': "Please enter a valid email address.",
  'contact.err.emailRequired': "Email is required.",
  'contact.err.messageRequired': "Message is required.",
  'contact.err.nameRequired': "Name is required.",
  'contact.form.email': "Email",
  'contact.form.emailPlaceholder': "your@email.com",
  'contact.form.error': "Something went wrong. Please try again.",
  'contact.form.error.rateLimit': "Too many attempts. Please try again in a few minutes.",
  'contact.form.footer': "No spam. We respond personally to every message.",
  'contact.form.message': "Message",
  'contact.form.messagePlaceholder': "Describe your issue, idea, or question...",
  'contact.form.name': "Name",
  'contact.form.namePlaceholder': "Your name",
  'contact.form.product': "Related Product",
  'contact.form.required': "required",
  'contact.form.send': "Send Message",
  'contact.form.sending': "Sending...",
  'contact.form.state.ready': "READY",
  'contact.form.state.sent': "SENT",
  'contact.form.subject': "Subject",
  'contact.form.subject.bug': "Bug Report",
  'contact.form.subject.feature': "Feature Request",
  'contact.form.subject.general': "General Inquiry",
  'contact.form.subject.partnership': "Partnership",
  'contact.form.subject.website': "I Need a Website",
  'contact.form.subtitle': "We'll get back to you within 24 hours.",
  'contact.form.title': "Send a Message",
  'contact.label': "// contact",
  'contact.product.defterkasa': "Defter Kasa",
  'contact.product.anilar': "Museum of Memories",
  'contact.product.general': "General / Other",
  'contact.product.kozmik': "Kozmik Journal",
  'contact.step1': "Describe your issue or idea",
  'contact.step2': "Fill in the form or email us",
  'contact.step3': "Get a personal response within 24h",
  'contact.success.another': "Send another →",
  'contact.success.body': "We'll respond within 24 hours.",
  'contact.success.thanks': "Thank you for reaching out.",
  'contact.success.title': "Message Sent!",
  'contact.title': "Say",
  'contact.title.sub': "Hello.",
  'dk.changelog.1.note': "PDF export, UI improvements, bug fixes",
  'dk.changelog.2.note': "Full rewrite with Jetpack Compose",
  'dk.changelog.3.note': "Invoice generation feature added",
  'dk.changelog.4.note': "Initial release",
  'dk.cta.play': "Google Play",
  'dk.cta.privacy': "Privacy Policy",
  'dk.cta.windows': "Download for Windows",
  'dk.description': "Professional bookkeeping and accounting for small businesses. Track income, expenses, invoices.",
  'dk.f1.desc': "Works without internet. All data is stored locally on your device. No cloud sync required, no server dependency.",
  'dk.f1.tag': "CORE",
  'dk.f1.title': "Fully Offline",
  'dk.f2.desc': "Track each customer's debt and payment history. See who owes what at a glance with a clean list view.",
  'dk.f2.tag': "FEATURE",
  'dk.f2.title': "Customer Ledger",
  'dk.f3.desc': "Create professional invoices in seconds. Export to PDF and share directly from the app.",
  'dk.f3.tag': "FEATURE",
  'dk.f3.title': "Invoice Generation",
  'dk.f4.desc': "Log daily expenses and income. Get a clear picture of your cash flow with simple summaries.",
  'dk.f4.tag': "FEATURE",
  'dk.f4.title': "Expense Tracking",
  'dk.f5.desc': "No analytics, no ads, no data collection. Your financial data stays on your device, period.",
  'dk.f5.tag': "PRIVACY",
  'dk.f5.title': "Privacy First",
  'dk.f6.desc': "Built with Kotlin and Jetpack Compose for smooth, native Android performance and Material 3 design.",
  'dk.f6.tag': "TECH",
  'dk.f6.title': "Performance",
  'dk.features.label': "// features",
  'dk.footer.left': "defter-kasa · a1.0.1 — stable",
  'dk.footer.right': "Finance · Android · Offline",
  'dk.meta': "a1.0.1 · Finance · Android",
  'dk.mock.recentTransactions': "Recent Transactions",
  'dk.mock.thisMonth': "This month +?4,750",
  'dk.mock.totalBalance': "Total Balance",
  'dk.mock.tx1.name': "Ahmet Y?lmaz",
  'dk.mock.tx2.name': "Invoice #0042",
  'dk.mock.tx3.name': "Expense Entry",
  'dk.mock.tx4.name': "Mehmet Demir",
  'dk.mock.tx5.name': "Ay?e Kaya",
  'dk.name': "Defter Kasa",
  'dk.name.line1': "Defter",
  'dk.name.line2': "Kasa",
  'dk.nav.download': "Download",
  'dk.nav.features': "Features",
  'dk.nav.specs': "Specs",
  'dk.privacy.back': "Back",
  'dk.privacy.breadcrumb.privacy': "Privacy",
  'dk.privacy.breadcrumb.products': "Products",
  'dk.privacy.cta.desc': "You can use the following channels for questions about this policy.",
  'dk.privacy.cta.email': "info@g-software.org",
  'dk.privacy.cta.github': "GitHub: altusparati",
  'dk.privacy.cta.question': "// questions?",
  'dk.privacy.intro': "Defter Kasa is a current account tracking application that aims to help you track business and customer records more systematically. This policy explains which information is accessed while using the app, how this information is processed, and for what purposes permissions are used.",
  'dk.privacy.lastUpdated': "Last updated: March 23, 2026",
  'dk.privacy.s01.content': "Defter Kasa is designed to manage business, customer, debt, payment, and note records created by the user. The goal is to keep daily business tracking fast and straightforward.",
  'dk.privacy.s01.isList': "false",
  'dk.privacy.s01.title': "General approach",
  'dk.privacy.s02.item0': "Records you create within the app are stored locally on your device.",
  'dk.privacy.s02.item1': "Files you select during backup or restore are used only to perform these operations.",
  'dk.privacy.s02.item2': "Credit card information is not collected or stored as part of routine app usage.",
  'dk.privacy.s02.title': "Collected and stored information",
  'dk.privacy.s03.item0': "Camera permission is used only to allow you to take photos with your explicit preference.",
  'dk.privacy.s03.item1': "Gallery or file selection access is activated when you want to add visuals to records.",
  'dk.privacy.s03.item2': "The visuals you select are stored on your device to be associated with the relevant records.",
  'dk.privacy.s03.title': "Camera and visual access",
  'dk.privacy.s04.item0': "Notification permission may be used to send reminders for upcoming or overdue records.",
  'dk.privacy.s04.item1': "Security features such as PIN or biometric lock are used to protect app access on your device.",
  'dk.privacy.s04.title': "Notifications and security",
  'dk.privacy.s05.item0': "If subscription or payment operations are offered, they are processed through Google Play infrastructure.",
  'dk.privacy.s05.item1': "The store, operating system, or selected backup channels may apply their own privacy policies separately.",
  'dk.privacy.s05.title': "Payment and platform services",
  'dk.privacy.s06.item0': "G-Soft does not aim to transfer business records to its own servers as part of routine usage.",
  'dk.privacy.s06.item1': "Your personal data is not sold.",
  'dk.privacy.s06.item2': "Data sharing is not intended outside of legal obligations or your explicit actions.",
  'dk.privacy.s06.title': "Data sharing",
  'dk.privacy.summary.0': "Data stored on device",
  'dk.privacy.summary.1': "Personal data not sold",
  'dk.privacy.summary.2': "Camera permission optional",
  'dk.privacy.summary.3': "Google Play infrastructure",
  'dk.privacy.summary.title': "Summary",
  'dk.privacy.title': "Privacy Policy",
  'dk.progress.label': "Development Progress",
  'dk.progress.stable': "a1.0.1 — stable",
  'dk.progress.status': "Production Ready",
  'dk.specs.appInfo': "App Info",
  'dk.specs.changelog': "Changelog",
  'dk.specs.cta': "Get on Google Play",
  'dk.specs.download': "Download",
  'dk.specs.label': "// technical specs",
  'dk.status': "LIVE",
  'footer.copyright': "© {{year}} G-Software · Built with Kotlin & React",
  'footer.nav.contact': "Contact",
  'footer.nav.privacy': "Privacy Policy",
  'footer.nav.products': "Products",
  'footer.nav.stack': "Stack",
  'footer.navigation': "Navigation",
  'footer.product.defterkasa.meta': "Finance · Android · LIVE",
  'footer.product.defterkasa.name': "Defter Kasa",
  'footer.product.kozmik.alt': "Kozmik Journal logo",
  'footer.product.kozmik.meta': "Lifestyle · Android - iOS · In Development",
  'footer.product.kozmik.name': "Kozmik Journal",
  'footer.products': "Products",
  'footer.systemStatus': "All systems operational",
  'footer.tagline': "Independent Android studio building privacy-first, offline-capable apps for real people. No cloud, no tracking, no nonsense.",
  'footer.values': "Privacy First · Offline First · Open Source",
  'games.am.category': "Atmospheric Story ? Mobile",
  'games.am.description': "A story-focused mobile concept centered on atmosphere, now archived and no longer in active development.",
  'games.am.longDescription': "Museum of Memories has been removed from active production and development has stopped. This page documents its final status and why it is no longer part of the active catalog.",
  'games.am.name': "Museum of Memories",
  'games.am.progressLabel': "Cancelled",
  'games.am.stat.platform': "Platform",
  'games.am.stat.release': "Release",
  'games.am.stat.status': "Status",
  'games.am.stat.version': "Version",
  'games.am.statValue.status': "Cancelled",
  'games.am.tag.archive': "Archive",
  'games.am.tag.atmosphere': "Atmosphere",
  'games.am.tag.mobile': "Mobile",
  'games.am.tag.storyDriven': "Story-driven",
  'games.archive.description': "Projects removed from active development and preserved as archive records.",
  'games.archive.label': "// archive",
  'games.archive.notInCatalog': "not in current catalog",
  'games.archive.note.0': "There is no active development.",
  'games.archive.note.1': "No store release or new version is planned.",
  'games.archive.note.2': "Legacy product notes are preserved as archive records.",
  'games.archive.note.3': "If the concept evolves into a new project, it will be published on a separate page.",
  'games.archive.notesLabel': "// archive notes",
  'games.archive.record': "Archive Record",
  'games.description': "Mobile games in development. Minimalist design, deep mechanics, fully offline. No ads, no pay-to-win.",
  'games.devProgress': "Dev Progress",
  'games.download': "Download",
  'games.exploreDesc': "Check out our productivity apps too.",
  'games.exploreMore': "// explore more",
  'games.inDevelopment': "In Development",
  'games.label': "// games",
  'games.live': "Live",
  'games.pd.description': "Turn-based pixel RPG with roguelike elements and deep crafting.",
  'games.pd.longDescription': "Pixel Dungeon X is a classic turn-based RPG with modern roguelike mechanics. Explore procedurally generated dungeons, collect rare loot, craft powerful gear, and face ancient bosses. Every run is different. Every death teaches you something.",
  'games.pd.progressLabel': "Concept Phase",
  'games.pd.stat.platform': "Platform",
  'games.pd.stat.release': "Release",
  'games.pd.stat.status': "Status",
  'games.pd.stat.version': "Version",
  'games.status.cancelled': "CANCELLED",
  'games.title': "Games",
  'games.total': "Total Games",
  'games.viewApps': "View Apps",
  'games.viewDetails': "View Details",
  'games.vr.description': "A fast-paced endless runner set in a dark void universe.",
  'games.vr.longDescription': "Void Runner drops you into an infinite dark corridor hurtling through space. Dodge procedurally generated obstacles, collect energy cores to power up, and compete on global leaderboards. Minimalist visuals, maximum adrenaline.",
  'games.vr.progressLabel': "Est. 2026 Q4",
  'games.vr.stat.platform': "Platform",
  'games.vr.stat.release': "Release",
  'games.vr.stat.status': "Status",
  'games.vr.stat.version': "Version",
  'hero.cta.github': "GitHub",
  'hero.cta.products': "View Products",
  'hero.description': "We design and build Android applications with a focus on privacy, performance, and clean user experience.",
  'hero.footer.tags': "Android · Privacy · Open Source",
  'hero.footer.version': "a1.0.1 — stable",
  'hero.label': "// independent software studio",
  'hero.stats.apps': "Live Apps",
  'hero.stats.downloads': "Downloads",
  'hero.stats.rating': "Avg Rating",
  'hero.typed.0': "that works.",
  'hero.typed.1': "that respects you.",
  'hero.typed.2': "without the cloud.",
  'hero.typed.3': "built to last.",
  'hero.typed.4': "for real people.",
  'kg.breadcrumb': "Kozmik Günlük",
  'kg.cta.features': "Explore Features",
  'kg.cta.soon': "Coming Soon",
  'kg.description': "Cosmic Diary is a visually focused digital journaling app that allows users to creatively express their emotions, thoughts, and memories. When an entry is completed, the text transforms into stars, trails of light, and cosmic details; each entry leaves a lasting mark on your personal universe.",
  'kg.f1.desc': "Write down your thoughts every day on a beautiful cosmic interface. Rich text support with mood indicators and timestamps.",
  'kg.f1.tag': "CORE",
  'kg.f1.title': "Daily Journaling",
  'kg.f2.desc': "Track your emotional journey with cosmic mood indicators. Visualize patterns in your mental health over time.",
  'kg.f2.tag': "FEATURE",
  'kg.f2.title': "Mood Tracking",
  'kg.f3.desc': "As you write, create your own universe. Your own galaxies, your own solar systems. Everything depends on you; a vast universe lies at your fingertips and IN YOUR HEART.",
  'kg.f3.tag': "FEATURE",
  'kg.f3.title': "Cosmic Themes",
  'kg.f4.desc': "Your private thoughts remain private. We cannot see even the smallest detail of what you write; your posts are stored locally on your own device.",
  'kg.f4.tag': "PRIVACY",
  'kg.f4.title': "Encrypted Entries",
  'kg.f5.desc': "Build a writing habit with daily series. Collect cosmic stars and unlock achievements as you write daily.",
  'kg.f5.tag': "GAMIFICATION",
  'kg.f5.title': "Streak System",
  'kg.f6.desc': "We don’t want to be an added burden when the worries in your heart are already weighing heavily on you. That’s why we’re designing the app to deliver optimal performance, so you can use your journal on your device as seamlessly as possible.",
  'kg.f6.tag': "TECH",
  'kg.f6.title': "Performance",
  'kg.features.label': "// features",
  'kg.footer.left': "kozmik-gunluk · v0 — development",
  'kg.footer.right': "Lifestyle · Android - iOS · Cosmic",
  'kg.meta': "v0 · Lifestyle · Android - iOS",
  'kg.mock.appShortName': "Kozmik",
  'kg.mock.day': "Day 7",
  'kg.mock.entry1.mood': "? Calm",
  'kg.mock.entry1.title': "Morning Walk",
  'kg.mock.entry2.mood': "? Inspired",
  'kg.mock.entry2.title': "New Ideas",
  'kg.mock.entry3.mood': "? Peaceful",
  'kg.mock.entry3.title': "End of Day",
  'kg.mock.entry4.mood': "? Mysterious",
  'kg.mock.entry4.title': "Dream Note",
  'kg.mock.recentEntries': "Recent Entries",
  'kg.mock.starsCollected': "142 stars collected",
  'kg.mock.today': "Today",
  'kg.name': "Kozmik Journal",
  'kg.name.line1': "Kozmik",
  'kg.name.line2': "Journal",
  'kg.nav.features': "Features",
  'kg.nav.notify': "Notify",
  'kg.nav.specs': "Specs",
  'kg.notify.btn': "Notify Me",
  'kg.notify.desc': "Cosmic Diary is currently in development. Leave your email address, join the beta programme and be the first to start writing in your diary. You’ll also be the first to know when the app is released.",
  'kg.notify.err.invalid': "Please enter a valid email address.",
  'kg.notify.err.required': "Email address is required.",
  'kg.notify.error': "Something went wrong. Please try again.",
  'kg.notify.error.rateLimit': "Too many attempts. Please try again in a few minutes.",
  'kg.notify.footer': "No spam. One email when we launch. That's it.",
  'kg.notify.label': "// notify me",
  'kg.notify.placeholder': "your@email.com",
  'kg.notify.sending': "Sending...",
  'kg.notify.stat.launch': "Target Launch",
  'kg.notify.stat.launchVal': "2027",
  'kg.notify.stat.platform': "Platform",
  'kg.notify.stat.platformVal': "Android - iOS",
  'kg.notify.stat.price': "Price",
  'kg.notify.stat.priceVal': "Free",
  'kg.notify.sublabel': "Launch Notification",
  'kg.notify.success.another': "Subscribe another email",
  'kg.notify.success.desc': "We'll reach out as soon as Kozmik Günlük is ready to launch.",
  'kg.notify.success.title': "You're on the list!",
  'kg.notify.title': "Be the first to",
  'kg.notify.title.accent': "explore the cosmos.",
  'kg.progress.label': "Development Progress",
  'kg.progress.status': "Est. 2027",
  'kg.progress.version': "v0 — in development",
  'kg.roadmap.1.note': "Initial release with core journaling features",
  'kg.roadmap.2.note': "Beta testing phase, bug fixes, performance improvements",
  'kg.roadmap.3.note': "Private beta with mood tracking and cosmic themes",
  'kg.roadmap.4.note': "Alpha release, basic journal functionality",
  'kg.roadmap.current': "Current",
  'kg.specs.appInfo': "App Info",
  'kg.specs.betaAccess': "Beta Access",
  'kg.specs.betaDesc': "Want early access to Kozmik Günlük? Join our beta program and be among the first to explore the cosmos.",
  'kg.specs.joinWaitlist': "Join Waitlist",
  'kg.specs.label': "// technical specs",
  'kg.specs.roadmap': "Roadmap",
  'kg.status': "In Development",
  'lang.en': "English",
  'lang.tr': "Turkish",
  'nav.apps': "Apps",
  'nav.contact': "Contact",
  'nav.games': "Games",
  'nav.home': "Home",
  'nav.notify': "Notify",
  'nav.stack': "Stack",
      'nav.websiteOffer': "Need a website?",
    'websvc.label': "// web design service",
    'websvc.title.line1': "Websites that fit your brand and",
    'websvc.title.accent': "bring real clients.",
    'websvc.subtitle': "We design web experiences that load fast, build trust instantly and make visitors say 'let us talk'.",
    'websvc.lead': "For us, a website is not just visual polish. It should communicate your value clearly and convert attention into demand.",
    'websvc.metrics.label': "premium standard",
    'websvc.metric.1.label': "first 3 sec",
    'websvc.metric.1.value': "trust + clarity",
    'websvc.metric.2.label': "mobile fit",
    'websvc.metric.2.value': "fluid experience",
    'websvc.metric.3.label': "business goal",
    'websvc.metric.3.value': "lead focused",
    'websvc.value.label': "why work with us",
    'websvc.value.title': "A structure that makes decisions easier",
    'websvc.value.1': "A clean premium visual language that elevates your brand perception",
    'websvc.value.2': "A frictionless flow that guides visitors step by step",
    'websvc.value.3': "Content architecture that explains your service in seconds",
    'websvc.value.4': "Consistent performance across phone, tablet and desktop",
    'websvc.value.5': "Right CTA at the right moment for more qualified inquiries",
    'websvc.pitch.label': "g-software approach",
    'websvc.pitch.title': "Your website stops being a brochure and becomes a working sales channel.",
    'websvc.pitch.body': "Nothing is random. Every headline, button and block is planned with user psychology in mind, so visitors take action instead of just scrolling.",
    'websvc.pitch.result': "RESULT: PREMIUM POSITIONING + MORE QUALIFIED LEADS",
    'websvc.services.label': "what we deliver",
    'websvc.card.1.title': "Positioning and Planning",
    'websvc.card.1.body': "We start by understanding your business and define a strategy that matches your target audience.",
    'websvc.card.2.title': "UI/UX Design",
    'websvc.card.2.body': "We craft clean, trustworthy interfaces aligned with your brand tone.",
    'websvc.card.3.title': "Modern Development",
    'websvc.card.3.body': "We build fast, mobile-ready and maintainable websites end to end.",
    'websvc.card.4.title': "Launch and Optimization",
    'websvc.card.4.body': "After launch, we improve the site continuously using feedback and performance data.",
    'websvc.process.label': "workflow",
    'websvc.step.1.title': "Discovery and Goals",
    'websvc.step.1.body': "We clarify your model, expectations and the exact outcome you want from your website.",
    'websvc.step.2.title': "Design and Build",
    'websvc.step.2.body': "We turn approved direction into a live-ready experience with performance-first code.",
    'websvc.step.3.title': "Launch and Growth",
    'websvc.step.3.body': "We launch, measure and keep refining to improve business impact over time.",
    'websvc.finalCta': "Get in touch now and let us start designing your website.",
    'websvc.finalSub': "Send us a message and we will map the right plan for your business.",
    'websvc.cta': "Start the Conversation",
  'product.back': "Back",
  'product.breadcrumb.products': "Products",
  'products.archive.notInCatalog': "not in current catalog",
  'products.archive.record': "Archive Record",
  'products.comingSoon': "Coming Soon",
  'products.googlePlay': "Google Play",
  'products.inDevelopment': "In Development",
  'products.items': "items",
  'products.label': "// products",
  'products.progress': "Progress",
  'products.status.cancelled': "CANCELLED",
  'products.status.dev': "IN DEV",
  'products.status.live': "LIVE",
  'products.status.soon': "SOON",
  'products.tab.apps': "Apps",
  'products.tab.games': "Games",
  'products.viewAll': "View All",
  'products.viewDetails': "View Details",
  'social.email': "Email",
  'social.github': "GitHub",
  'social.instagram': "Instagram",
  'social.x': "X",
  'social.tiktok': "TikTok",
  'social.toggle': "Social",
  'stack.label': "// how we build",
  'stack.p1.body': "Every app we build is local-first. Your data never leaves your device unless you explicitly choose to sync it. No analytics, no tracking, no ads.",
  'stack.p1.tag': "CORE PRINCIPLE",
  'stack.p1.title': "Privacy by Design",
  'stack.p2.body': "Internet connection should be optional, not required. Our apps work fully offline and sync when connectivity is available.",
  'stack.p2.tag': "ARCHITECTURE",
  'stack.p2.title': "Offline First",
  'stack.p3.body': "We obsess over UI details. Every pixel, every animation, every interaction is intentional. Good design is invisible.",
  'stack.p3.tag': "DESIGN",
  'stack.p3.title': "Clean Interfaces",
  'stack.p4.body': "Transparency builds trust. The information we request from you and the information we use is set out in the privacy policy for each of our mobile apps.",
  'stack.p4.tag': "PHILOSOPHY",
  'stack.p4.title': "Trust",
  'stack.techLabel': "// tech stack",
};
